import * as _ from 'lodash';
import { analysticsConstant } from '../constants/analysticsConstant';
import {trackOrderEvent} from '../services/analytics-util';
import * as appConstants from '../constants/AppConstants';
import ApprovalService from "../services/ApprovalService";



export function createAddonsAnalyticsLog(selectedApproval) {
  const metadata  = _.has(selectedApproval, 'approvalMetaData.analyticsLogOtherDetails') ? selectedApproval.approvalMetaData.analyticsLogOtherDetails: '';
  try {
    const analysticsObj = {
      pageName: analysticsConstant.CUSTOMER_APPORVAL_PORTAL,
      action: analysticsConstant.PURCHASE,
      agentLdap: metadata.agentLdap,
      customerGuid: _.has(metadata, 'customerGuid') ? metadata.customerGuid : '',
      customerEmail: _.has(metadata, 'customerEmail') ? metadata.customerEmail : '',
      customerCountryCode: _.has(metadata, 'customerCountryCode') ? metadata.customerCountryCode : '',
      customerRegion: _.has(metadata, 'customerRegion') ? metadata.customerRegion : '',
      totalValue: _.has(metadata, 'totalValue') ? metadata.totalValue : '',
      currencyCode: _.has(metadata, 'currencyCode') ? metadata.currencyCode : '',
      products: _.has(metadata, 'products') ? metadata.products : '',
      purchaseID: _.has(metadata, 'purchaseID') ? metadata.purchaseID : '',
      orderType: _.has(metadata, 'orderType') ? metadata.orderType : '',
      paymentCategory: _.has(metadata, 'paymentCategory') ? metadata.paymentCategory : '',
      paymentType: _.has(metadata, 'paymentType') ? metadata.paymentType : '',
      paymentSubType: _.has(metadata, 'paymentSubType') ? metadata.paymentSubType : '',
      marketSegment:_.has(metadata, 'marketSegment') ? metadata.marketSegment : '',
      orderNumber: _.has(metadata, 'orderNumber') ? metadata.orderNumber : '',
      arrTotalWithoutTax: _.has(metadata, 'arrTotalWithoutTax') ? metadata.arrTotalWithoutTax : '',
      arrTotalWithTax: _.has(metadata, 'arrTotalWithTax') ? metadata.arrTotalWithTax : '',
      agentCallCenter: _.has(metadata, 'agentCallCenter') ? metadata.agentCallCenter : '',
      agentPersona: _.has(metadata, 'agentPersona') ? metadata.agentPersona : '',
      agentEmployeeType: _.has(metadata, 'agentEmployeeType') ? metadata.agentEmployeeType : '',
      agentOrganization: _.has(metadata, 'agentOrganization') ? metadata.agentOrganization : '',
      agentChannel: _.has(metadata, 'agentChannel') ? metadata.agentChannel : '',
      agentGeolocation: _.has(metadata, 'agentGeolocation') ? metadata.agentGeolocation : '',
      agentProfileChannel: _.has(metadata, 'agentProfileChannel') ? metadata.agentProfileChannel : '',
      internalOrderType:_.has(metadata, 'internalOrderType') ? metadata.internalOrderType : '',
      orderCategory:_.has(metadata, 'orderCategory') ? metadata.orderCategory : '',
      paymentSource:_.has(metadata, 'paymentSource') ? metadata.paymentSource : '',
      flowType: 'Team Addons',
      flowSubType: _.has(metadata, 'flowSubType') ? metadata.flowSubType : '',
      requestType: analysticsConstant.EVENT,
      ARROrderTotalWithTax: '',
      ARROrderTotalWithoutTax: '',
      ctaId:_.has(metadata, 'ctaId') ? metadata.ctaId : '',
    // Pure Sales Profile from head count tracker data
      agentSalesCenter :  _.has(metadata, 'agentSalesCenter') ? metadata.agentSalesCenter : '',
      agentSalesGeolocation : _.has(metadata, 'agentSalesGeolocation') ? metadata.agentSalesGeolocation : '',
      agentRepName : _.has(metadata, 'agentRepName') ? metadata.agentRepName : '',
      agentTsm : _.has(metadata, 'agentTsm') ? metadata.agentTsm : '',
      agentTsmLdap: _.has(metadata, 'agentTsmLdap') ? metadata.agentTsmLdap : '',
      agentManager: _.has(metadata, 'agentManager') ? metadata.agentManager : '',
      agentManagerLdap: _.has(metadata, 'agentManagerLdap') ? metadata.agentManagerLdap : '',
      agentFinalTeam : _.has(metadata, 'agentFinalTeam') ? metadata.agentFinalTeam : '',
      agentActiveFlag : _.has(metadata, 'agentActiveFlag') ? metadata.agentActiveFlag : '',
      agentShiftTime : _.has(metadata, 'agentShiftTime') ? metadata.agentShiftTime : '',
      agentTimeZone : _.has(metadata, 'agentTimeZone') ? metadata.agentTimeZone : '',
      agentAgentStartDate: _.has(metadata, 'agentAgentStartDate') ? metadata.agentAgentStartDate : '',
      agentQuarter: _.has(metadata, 'agentQuarter') ? metadata.agentQuarter : '',
      agentTag: _.has(metadata, 'agentTag') ? metadata.agentTag : '',
      supportAgentName: _.has(metadata, 'supportAgentName') ? metadata.supportAgentName : '',
      supportAgentEmployeeType: _.has(metadata, 'supportAgentEmployeeType') ? metadata.supportAgentEmployeeType : '',
      supportAgentEEBusinessUnit: _.has(metadata, 'supportAgentEEBusinessUnit') ? metadata.supportAgentEEBusinessUnit : '',
      supportAgentActiveStatus: _.has(metadata, 'supportAgentActiveStatus') ? metadata.supportAgentActiveStatus : '',
  };

    if(analysticsObj && analysticsObj.flowSubType && analysticsObj.flowSubType === 'TEAM_CHANGE_PLAN'){
      analysticsObj.flowType = 'Team Change Plan';
    }

    if (analysticsObj.currencyCode === 'USD') {
      analysticsObj.ARROrderTotalWithoutTax = analysticsObj.arrTotalWithoutTax;
      analysticsObj.ARROrderTotalWithTax = analysticsObj.arrTotalWithTax;
      trackOrderEvent(analysticsObj);
    } else {
      if (analysticsObj.arrTotalWithoutTax || analysticsObj.arrTotalWithTax) {
        if (analysticsObj.arrTotalWithoutTax) {
          ApprovalService.getCurrencyConversionConfig(analysticsObj.currencyCode, analysticsObj.arrTotalWithoutTax).then(
            function (resp) {
              analysticsObj.ARROrderTotalWithoutTax = resp && resp.data.valueInUSD ? resp.data.valueInUSD.toFixed(2) : '';
              if (analysticsObj.totalValue) {
                ApprovalService.getCurrencyConversionConfig(analysticsObj.currencyCode, analysticsObj.arrTotalWithTax).then(
                  function (resp) {
                    analysticsObj.ARROrderTotalWithTax = resp && resp.data.valueInUSD ? resp.data.valueInUSD.toFixed(2) : '';
                    trackOrderEvent(analysticsObj);
                  },
                  function () {
                    _.has(metadata, 'ARROrderTotalWithTax') && (analysticsObj.ARROrderTotalWithTax = metadata.ARROrderTotalWithTax);
                    trackOrderEvent(analysticsObj);
                  }
                );
              }
            },
            function () {
              _.has(metadata, 'ARROrderTotalWithoutTax') && (analysticsObj.ARROrderTotalWithoutTax = metadata.ARROrderTotalWithoutTax);
              _.has(metadata, 'ARROrderTotalWithTax') && (analysticsObj.ARROrderTotalWithTax = metadata.ARROrderTotalWithTax);
              trackOrderEvent(analysticsObj);
            }
          );
        } else if (analysticsObj.arrTotalWithTax) {
          ApprovalService.getCurrencyConversionConfig(analysticsObj.currencyCode, analysticsObj.arrTotalWithTax).then(
            function (resp) {
              analysticsObj.ARROrderTotalWithTax = resp && resp.data.valueInUSD ? resp.data.valueInUSD.toFixed(2) : '';
              trackOrderEvent(analysticsObj);
            },
            function () {
              _.has(metadata, 'ARROrderTotalWithTax') && (analysticsObj.ARROrderTotalWithTax = metadata.ARROrderTotalWithTax);
              trackOrderEvent(analysticsObj);
            }
          );
        }
      }
    }
  } catch (e) {
    //
  }
}

export const getFormattedPrice = (price, country) => {
  let formattedPrice = '';
  const productPrice = price !== '' && typeof price === 'string' ? parseFloat(price.replace(/,/g, '')) : Number(price);
  if (price) {
    if (['BH', 'JO', 'KW', 'OM'].includes(country)) {
      formattedPrice =
        typeof productPrice === 'string'
          ? parseFloat(productPrice)
              .toFixed(3)
              .replace(/\d(?=(\d{3})+\.)/g, '$&,')
          : productPrice.toFixed(3).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    } else {
      formattedPrice =
        typeof productPrice === 'string'
          ? parseFloat(productPrice)
              .toFixed(2)
              .replace(/\d(?=(\d{3})+\.)/g, '$&,')
          : productPrice.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    }
  } else if (price === undefined || price === null || price === 0 || price.length === 0) {
    price = 0;
    if (appConstants.THREE_DECIMAL_PRICE_COUNTRIES.includes(country)) {
      formattedPrice =
        typeof productPrice === 'string'
          ? parseFloat(productPrice)
              .toFixed(3)
              .replace(/\d(?=(\d{3})+\.)/g, '$&,')
          : productPrice.toFixed(3).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    } else {
      formattedPrice =
        typeof productPrice === 'string'
          ? parseFloat(productPrice)
              .toFixed(2)
              .replace(/\d(?=(\d{3})+\.)/g, '$&,')
          : productPrice.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    }
  }
  return formattedPrice;
};

export const getDrTotalPrice = (productList) => {
  let totalValue = 0;
  if (productList && productList.length > 0) {
    productList.forEach(function (product) {
      totalValue += product.seatQuantity * product.priceInfo.oneUnitPriceWithoutTax;
    });
  }
  return totalValue;
};

export const getTotalPrice = (productList) => {
  let totalValue = 0;
  if (productList && productList.length > 0) {
    productList.forEach(function (product) {
      totalValue += product.seatQuantity * product.price.billable_items.price_details.unit_next_billing.amount_with_tax;
    });
  }
  return totalValue;
};

export const getTotalPriceWthoutTax = (productList) => {
  let totalValue = 0;
  if (productList && productList.length > 0) {
    productList.forEach(function (product) {
      totalValue += product.seatQuantity * product.price.billable_items.price_details.unit_next_billing.amount_without_tax;
    });
  }
  return totalValue;
};

export const fetchCurrencyCode = (contractDetails, productList) => {
  let currencyCode = _.has(contractDetails, 'currencyCode') ? contractDetails.currencyCode : '';
  if (currencyCode === '' && productList && productList.length > 0) {
    currencyCode =
      productList[0] && productList[0].price && productList[0].price.nextBillingCurrencyCode
        ? productList[0].price.nextBillingCurrencyCode
        : '';
  }
  return currencyCode;
};

export const getProductInfo = (productList) => {
  let productString = '';
  if (productList.length > 0) {
    productList.forEach(function (orderItem, key) {
      const productName = _.has(orderItem, 'productName') ? orderItem.productName : '';
      const productQnty = _.has(orderItem, 'quantity') ? orderItem.quantity : 0;
      let productPrice = _.has(orderItem, 'price.billable_items.price_details.unit_next_billing.amount_without_tax')
        ? orderItem.price.billable_items.price_details.unit_next_billing.amount_without_tax
        : 0;
      if (productPrice === 0) {
        productPrice = _.has(orderItem, 'price.billable_items.price_details.unit_next_billing.amount_with_tax')
          ? orderItem.price.billable_items.price_details.unit_next_billing.amount_with_tax
          : 0;
      }
      productString += `;${productName}`;
      productString += `;${productQnty}`;
      productString += `;${productPrice}`;
      if (productList.length > key + 1) {
        productString += ',';
      }
    });
  }
  return productString;
};

export const getPaymentCategory = (category) => {
  let paymentCategory = '';

  switch (category) {
    case 'CREDIT_CARD':
      paymentCategory = 'Online';
      break;
    case 'DIRECT_DEBIT':
      paymentCategory = 'Online';
      break;
    case 'DEBIT':
      paymentCategory = 'Online';
      break;
    case 'OFFLINE':
      paymentCategory = 'Offline';
      break;
    case 'PURCHASE_ORDER':
      paymentCategory = 'Online';
      break;
    case 'PAYPAL':
      paymentCategory = 'Online';
      break;
    default:
      break;
  }
  return paymentCategory;
};

export const getMarketSeg = (marketSeg) => {
  if (marketSeg === 'COMMERCIAL') {
    return 'COM';
  } else if (marketSeg === 'EDUCATION') {
    return 'EDU';
  } else {
    return '';
  }
};

export const getArrAmount = (price, productCode, billingFrequency) => {
  price = parseFloat(price.replace(/,/g, ''));
  let arrAmount = 0;
  if (productCode === 'STEL') {
    arrAmount = parseFloat(price);
  } else if (billingFrequency === 'MONTHLY') {
    arrAmount = parseFloat(price) * 12;
  } else if (billingFrequency === 'ANNUAL') {
    arrAmount = parseFloat(price);
  } else {
    arrAmount = parseFloat(price);
  }
  return parseFloat(arrAmount.toFixed(2));
};